/**
 * Created by Samj on 2017/7/18.
 */
import React from 'react';
import miment from 'miment';
import {FormattedMessage} from 'react-intl';
import {ysConfirm, ysMessage, ysTitle} from "../components/yunshl/Dialog/DialogAction";
import MathUtil from "./math-utils"
import StorageUtil from "./storage-util";
import {SystemConst} from "./constant";
import CheckUtil from "./check-util";

import zh_CN from "../locale/zh_CN"; // 中文
import es_ES from "../locale/es_ES";
import en_US from "../locale/en_US" // 英语
// 多语言 XIAOMI654321
const messages = {
    'zh': zh_CN,
    'es': es_ES,
    'en': en_US
};
const lang = StorageUtil.getItem(SystemConst.lang) || 'zh';


function pad(num, length) {
    return (num + "0000000000000000").substr(0, length);
}


const FormatUtil = {
    //商品价格精度
    priceScale(value, scale) {
        if (isNaN(Number(value))) return;
        const currencySymbol = StorageUtil.getItem(SystemConst.currencySymbol);
        var s = scale || StorageUtil.getItem(SystemConst.priceScale) || 2;
        var times = Math.pow(10, s);
        var s1 = value.toString();
        var valArr = s1.split(".");
        var m = valArr[1] ? valArr[1].length : 0;

        var priceZoom = (s1 * Math.pow(10, m)) * times / Math.pow(10, m);
        var des = parseInt(priceZoom + 0.5, 10) / times;
        return currencySymbol + (+des.toFixed(s));

    },
    //商品价格精度
    priceScaleNoChar: function (value, scale) {

        if (isNaN(Number(value))) return;
        var s = scale || StorageUtil.getItem(SystemConst.priceScale) || 2;
        var times = Math.pow(10, s);
        var s1 = value.toString();
        var valArr = s1.split(".");
        var m = valArr[1] ? valArr[1].length : 0;
        var priceZoom = (s1 * Math.pow(10, m)) * times / Math.pow(10, m);
        var des = parseInt(priceZoom + 0.5, 10) / times;
        return +des.toFixed(s);
    },
    countScale: function (value, scale) {
        if (CheckUtil.isNumber(value)) {
            var s = scale ? scale : (window.countScale ? window.countScale : StorageUtil.getItem(SystemConst.countScale));
            var i, f;
            var arr = (value + '').split('.');
            if (arr.length == 2) {
                i = arr[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
                f = pad(arr[1].substr(0, s), s);
                if (s == 0) {
                    return +i;
                } else {
                    return +(i + '.' + f);
                }
            } else {
                if (s === 0) {
                    return +(arr[0].replace('null', 0));

                } else {
                    return +(arr[0].replace('null', 0));
                }
            }
        } else {
            return ''
        }
    },

    date: (v) => {
        if (!v) {
            return ''
        }
        return v.split(' ')[0].replace(new RegExp(/(-)/g), '-');
    },

    showStock: (stock, scale = 1) => {
        let type = StorageUtil.getItem(SystemConst.stockShowType);
        let showStock = parseInt(stock / scale);
        switch (type) {
            case 1:
                if (lang === 'es') {
                    return showStock > 0 ? 'En stock' : 'Fuera de stock'
                } else {
                    return showStock > 0 ? `有货` : `无货`;
                }
            case 2:
                return showStock > 0 ? showStock : 0;
            default:
                return undefined;
        }
    },

    priceUnit(price) {
        if (!price) return;
        if (price > 100000000) {
            return (price / 100000000).toFixed(2) + '亿'
        } else if (price > 10000000) {
            return (price / 10000000).toFixed(2) + '千万'
        } else if (price > 1000000) {
            return (price / 1000000).toFixed(2) + '百万'
        } else if (price > 10000) {
            return (price / 10000).toFixed(2) + '万'
        } else {
            return price.toFixed(2)
        }
    },
    countUnit(count) {
        if (!count) return;
        if (count > 100000000) {
            return (count / 100000000).toFixed(2) + '亿'
        } else if (count > 10000000) {
            return (count / 10000000).toFixed(2) + '千万'
        } else if (count > 1000000) {
            return (count / 1000000).toFixed(2) + '百万'
        } else if (count > 10000) {
            return (count / 10000).toFixed(2) + '万'

        } else {
            return count
        }
    },

};
const NumberUtil = {

    //精度,默认两位
    scale: (v, s = 2) => {
        if (CheckUtil.isNumber(v)) {
            return Math.round(v * Math.pow(10, s)) / Math.pow(10, s);
        } else {
            return 0;
        }
    },
    toNumber: (v) => {
        return Number(v) || 0;
    },
    //v1+v2
    add: (v1, v2, s = 2) => {
        return NumberUtil.scale(v1, s) + NumberUtil.scale(v2, s);
    },
    // v1-v2
    sub: (v1, v2, s = 2) => {
        return NumberUtil.scale(v1, s) - NumberUtil.scale(v2, s);
    },
    unsignSub: (v1, v2, s = 2) => {
        let result = NumberUtil.scale(v1, s) - NumberUtil.scale(v2, s);
        return result > 0 ? result : 0;
    },
    // v1*v2
    mul: (v1, v2, s = 2) => {
        return NumberUtil.scale(v1, s) * NumberUtil.scale(v2, s);
    },

    // v1/v2
    div: (v1, v2, s = 2) => {
        return NumberUtil.scale(v1, s) / (NumberUtil.scale(v2, s) == 0 ? 1 : NumberUtil.scale(v2, s));
    },

};
const Util = {
    confirm: (content, option) => {
        return ysConfirm(content, option);
    },
    message: (message, option) => {
        return ysMessage(message, option);
    },
    title: (title, content, option) => {
        return ysTitle(title, content, option);
    },
    twoDecNumber(num) {
        num = num.replace(/[^\d.]/g, "");  //清除“数字”和“.”以外的字符
        num = num.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
        num = num.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
        num = num.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3');//只能输入两个小数
        if (num.indexOf(".") < 0 && num != "") {//以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
            num = parseFloat(num);
        }
        return num;
    },

    toParse(value, back = {}) {
        // back ：错误返回值，默认返回对象
        switch (typeof value) {
            case 'object' :
                return value === null ? {} : value;
                break;
            default:
                try {
                    return JSON.parse(value)
                } catch (e) {
                    return back
                }
                break;
        }


    },
    formatTime(time, format) {
        //时间格式化
        return miment(time).format(format)
    },
    timeTranslate(timer) {
        if ((!timer && timer !== 0) || timer < 0) return {};
        //计算出相差天数
        let days = Math.floor(timer / (24 * 3600 * 1000));
        //计算出相差小时数
        let leave1 = timer % (24 * 3600 * 1000); //计算天数后剩余毫秒数
        let hours = Math.floor(leave1 / (3600 * 1000));

        //计算出相差分钟数
        let leave2 = leave1 % (3600 * 1000);
        let minutes = Math.floor(leave2 / (60 * 1000));

        //计算出相差秒数
        let leave3 = leave2 % (60 * 1000);
        let seconds = Math.round(leave3 / 1000);
        //计算出剩余毫秒数
        let leave4 = leave3 % (1000);
        let msec = Math.round(leave4).toString().charAt(0);

        //字符串
        let time = '';

        if (days > 0) {
            time = `剩 <i>${days}</i> 天`;
        } else if (hours > 0) {
            time = `剩 <i>${hours}</i> 小时`;
        } else {
            time = `<i>${minutes}</i> 分 <i>${seconds}</i> 秒 <i>${msec}</i>`;
        }

        return {
            d: days, //天
            h: this.comple(hours),//小时
            m: this.comple(minutes),//分钟
            s: this.comple(seconds),//秒
            ms: msec,//豪秒
            time: time
        }
    },
    datetimeFormat(time) {
        let seconds = time / 1000;
        switch (true) {
            case seconds <= 60:
                return "刚刚";
            case seconds > 60 && seconds <= 3600:
                return Math.floor(seconds / 60) + "分钟前";
            case seconds > 3600 && seconds <= 3600 * 24:
                return Math.floor(seconds / 3600) + "小时前";
            case seconds > 3600 * 24 && seconds <= 3600 * 24 * 30:
                return Math.floor(seconds / (3600 * 24)) + "天前";
            case seconds > 3600 * 24 * 30 && seconds <= 3600 * 24 * 30 * 12:
                return Math.floor(seconds / (3600 * 24 * 30)) + "个月前";
            case seconds > 3600 * 24 * 30 * 12 :
                return Math.floor(seconds / (3600 * 24 * 30 * 12)) + "年前";
            default:
                return "未知类型";
        }
    },
    comple(v) {
        return (v >= 10 || v < 0) ? v : `0${v}`
    },
    formatIosTime(t) {
        return t.replace(/\-/g, "/");
    },
};

const GoodsPriceUtil = {
    getPrice: (model, isLogin) => {
        if (!model) {
            return;
        }
        if (model.client_price_ == -1) {
            return <FormattedMessage id={'DLCKJG'} defaultValue='登录查看价格'/>;
        }

        //没登录+不允许游客查看价格
        if (GoodsPriceUtil.shouldToLogin(model, isLogin)) {
            return <FormattedMessage id={'DLCKJG'} defaultValue='登录查看价格'/>;
        }
        let price = isLogin ? model.client_price_ : model.client_price_;
        let price_String = FormatUtil.priceScale(price);
        if (GoodsPriceUtil.isMorePrice(model, isLogin)) {
            price_String = FormatUtil.priceScale(GoodsPriceUtil.getMiniPrice(model, isLogin)) + " - " + FormatUtil.priceScale(GoodsPriceUtil.getMaxPrice(model, isLogin));
        }

        return price_String;
    },
    getPriceNoChar: (model, isLogin, promotionInfo) => {
        if (!model) {
            return;
        }
        if (model.client_price_ == -1) {
            return <FormattedMessage id={'DLCKJG'} defaultValue='登录查看价格'/>;
        }

        //没登录+不允许游客查看价格
        if (GoodsPriceUtil.shouldToLogin(model, isLogin)) {
            return <FormattedMessage id={'DLCKJG'} defaultValue='登录查看价格'/>;
        }
        let price = isLogin ? model.client_price_ : model.client_price_;
        let price_String = FormatUtil.priceScaleNoChar(price);
        if (GoodsPriceUtil.isMorePrice(model, isLogin, promotionInfo)) {
            if (GoodsPriceUtil.getMiniPrice(model, isLogin, promotionInfo) === FormatUtil.priceScaleNoChar(GoodsPriceUtil.getMaxPrice(model, isLogin, promotionInfo))) {
                price_String = GoodsPriceUtil.getMiniPrice(model, isLogin, promotionInfo);
            } else {
                price_String = FormatUtil.priceScaleNoChar(GoodsPriceUtil.getMiniPrice(model, isLogin, promotionInfo)) + " - " + FormatUtil.priceScaleNoChar(GoodsPriceUtil.getMaxPrice(model, isLogin, promotionInfo));
            }
        }

        return price_String;
    },

    getMiniPrice: (model, isLogin, promotionInfo) => {
        if (!model) {
            return;
        }
        let priceArr = [];
        for (var index = 0; index < model.productList.length; index++) {
            var element = model.productList[index];
            const promotion = promotionInfo && promotionInfo[element.id_];
            let tmpPrice = element.client_price_;
            if (promotion && !promotion.is_stair_) {
                if (promotion.price_) {
                    tmpPrice = promotion.price_
                }
                if (promotion.cuted_percent_) {
                    tmpPrice = MathUtil.mul(promotion.cuted_percent_ / 100, element.client_price_)
                }
            }
            //过滤0
            if (tmpPrice > 0) {
                priceArr.push(tmpPrice)
            }
        }

        let price = Math.min.apply(null, priceArr);
        return (MathUtil.mul(price, (model.unitScale || 1)));
    },

    getMaxPrice: (model, isLogin, promotionInfo) => {
        if (!model) {
            return;
        }
        let priceArr = [];

        for (var index = 0; index < model.productList.length; index++) {
            var element = model.productList[index];
            const promotion = promotionInfo && promotionInfo[element.id_];
            let tmpPrice = element.client_price_;
            if (promotion && !promotion.is_stair_) {
                if (promotion.price_) {
                    tmpPrice = promotion.price_
                }
                if (promotion.cuted_percent_) {
                    tmpPrice = MathUtil.mul(promotion.cuted_percent_ / 100, element.client_price_)
                }
            }

            if (tmpPrice > 0) {
                priceArr.push(tmpPrice)
            }
        }
        let price = Math.max.apply(null, priceArr);
        return (price * (model.unitScale || 1));
    },

    isMorePrice: (model, isLogin, promotionInfo) => {
        let isMorePrice = false;

        if (!model || !model.productList || model.productList.length == 1) {
            return isMorePrice;
        }

        let price = model.client_price_;
        for (var index = 0; index < model.productList.length; index++) {
            var element = model.productList[index];
            const promotion = promotionInfo && promotionInfo[element.id_];
            if (typeof element !== 'object') return;
            if (!element) return;
            let tmpPrice = element.client_price_;
            if (promotion && !promotion.is_stair_) {
                if (promotion.price_) {
                    tmpPrice = promotion.price_
                }
                if (promotion.cuted_percent_) {
                    tmpPrice = MathUtil.mul(promotion.cuted_percent_ / 100, element.client_price_)
                }
            }
            if (price != tmpPrice) {
                isMorePrice = true;
                break;
            }
        }
        return isMorePrice;
    },
    // 获取规格价格，用于购物车,订单
    getProductPrice(goods, product) {
        // 多单位指定价处理
        let _price = product.client_price_;
        if (goods.is_multi_unit_ && goods.unit_id_ !== (product.unitId || product.unit_id_)) {
            //unitId:加入购物车所选单位，spec.unit_id_：购物车订单列表规格所选单位
            (goods.multi_unit_.extend_units_ || []).map((unit, index) => {
                if (unit.unit_id_ === (product.unitId || product.unit_id_)) {
                    switch (index) {
                        case 0:
                            _price = product.unit_price_ || MathUtil.mul(_price, (unit.scale_ || 1));
                            break;
                        case 1:
                            _price = product.unit2_price_ || MathUtil.mul(_price, (unit.scale_ || 1));
                            break;
                    }
                }
            })
        }
        return _price;
    },

    shouldToLogin: (model, isLogin) => {
        if (!model) {
            return false;
        }
        if (!model.allow_client_price_ && !isLogin) {
            return true;
        }
        return false;
    },

};
const ColorUtil = {
    // 十六进制颜色转RGB
    colorRgb(color, alpha) {
        let sColor = color.toLowerCase();
        // 十六进制颜色值的正则表达式
        let reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
        // 如果是16进制颜色
        if (sColor && reg.test(sColor)) {
            if (sColor.length === 4) {
                let sColorNew = "#";
                for (let i = 1; i < 4; i += 1) {
                    sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1));
                }
                sColor = sColorNew;
            }
            // 处理六位的颜色值
            let sColorChange = [];
            for (let i = 1; i < 7; i += 2) {
                sColorChange.push(parseInt("0x" + sColor.slice(i, i + 2)));
            }
            if (typeof alpha === 'number') {
                sColorChange.push(alpha / 100);
                return "RGBA(" + sColorChange.join(",") + ")";
            }
            return "RGB(" + sColorChange.join(",") + ")";
        }
        return sColor;
    },
    getBackgroundColor(theme, alpha, gradual) {
        const rgbaAlpha = ColorUtil.colorRgb('#' + theme, (alpha || '60'));
        const rgba = ColorUtil.colorRgb('#' + theme, '100');
        return {
            // background: `linear-gradient(180deg,${rgbaAlpha} 0%, ${rgba}${gradual || 68}%, ${rgba}100%)`, // fix:YSDH-14560
            background: rgba,
        }
    }
};

export default Util;
export {FormatUtil, CheckUtil, NumberUtil, GoodsPriceUtil, ColorUtil}



// WEBPACK FOOTER //
// ./src/utils/Utils.js